'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, Loader2, User } from 'lucide-react';
import type { PortalRememberHint } from '@/features/portal/types/portalTypes';
interface PortalRememberCardProps {
  hint: PortalRememberHint;
  onContinue: () => void;
  onForget: () => void;
  isContinuing?: boolean;
  isForgetting?: boolean;
}
export function PortalRememberCard(t0) {
  const $ = _c(22);
  const {
    hint,
    onContinue,
    onForget,
    isContinuing: t1,
    isForgetting: t2
  } = t0;
  const isContinuing = t1 === undefined ? false : t1;
  const isForgetting = t2 === undefined ? false : t2;
  const anyPending = isContinuing || isForgetting;
  const subtitle = hint.type === "EMAIL" ? "Continuar com este e-mail" : "Continuar com este CPF";
  let t3;
  if ($[0] !== isContinuing) {
    t3 = <div className="bg-brand-50 flex size-10 shrink-0 items-center justify-center rounded-[8px]">{isContinuing ? <Loader2 className="text-brand-700 size-5 animate-spin" /> : <User className="text-brand-700 size-5" />}</div>;
    $[0] = isContinuing;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== subtitle) {
    t4 = <span className="text-sm text-neutral-500">{subtitle}</span>;
    $[2] = subtitle;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== hint.hint) {
    t5 = <span className="text-sm font-medium text-[--color-text-heading-dark]">{hint.hint}</span>;
    $[4] = hint.hint;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <div className="flex flex-1 flex-col gap-1">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ArrowRight className="size-5 shrink-0 text-neutral-400" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== anyPending || $[11] !== onContinue || $[12] !== t3 || $[13] !== t6) {
    t8 = <button type="button" onClick={onContinue} disabled={anyPending} className="flex w-full items-center gap-3 rounded-[16px] border border-neutral-200 bg-white px-4 py-5 text-left shadow-[0px_1px_2px_0px_rgba(24,29,39,0.08)] transition-colors hover:bg-neutral-50 disabled:cursor-not-allowed disabled:opacity-60">{t3}{t6}{t7}</button>;
    $[10] = anyPending;
    $[11] = onContinue;
    $[12] = t3;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = isForgetting ? "Esquecendo..." : "N\xE3o sou eu / esquecer este dispositivo";
  let t10;
  if ($[15] !== anyPending || $[16] !== onForget || $[17] !== t9) {
    t10 = <button type="button" onClick={onForget} disabled={anyPending} className="hover:text-brand-700 self-center text-sm font-medium text-neutral-500 transition-colors disabled:cursor-not-allowed disabled:opacity-60">{t9}</button>;
    $[15] = anyPending;
    $[16] = onForget;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <div className="flex w-full flex-col gap-3">{t8}{t10}</div>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}